import {createSelector} from "reselect";
import {IStore} from "modules/types";

export const getSecretPageStore = (store: IStore) => store.secretPage;

export const getIsShowSecretPage = createSelector(
	getSecretPageStore,
	({isShowSecretPage}) => isShowSecretPage
);
